module.exports = __webpack_public_path__ + "static/media/banner_crypto.4c08e153.png";